<style lang="less">
  // @import '../flow.less';
  @import '../flow.less';
</style>

<template>
  <div>
  <Card>
      <Row>
        <i-col span="24" :md="16">
          <Form ref="searchForm" inline :model="searchForm" :label-width="120" @submit.native.prevent>
            <FormItem label="申请人/项目名/描述" prop="name">
              <i-input v-model="searchForm.name" placeholder="请输入申请人/项目名/描述" style="width: 200px;"></i-input>
            </FormItem>
            <FormItem :label-width="0" class="mob-align-right">
              <Button type="primary" @click="getGitFlowsList()">搜索</Button>
              <Button @click="searchReset" style="margin-left: 10px;">重置</Button>
            </FormItem>
          </Form>
        </i-col>
        <i-col span="24" :md="8">
          <Button style="float: right;" v-show="isGitflowAdd" @click="AddGitflow()" type="primary" :style="{marginBottom: '10px'}" icon="md-add">添加Git流水线</Button>
        </i-col>
       </Row>
      <tables search-place="top" v-model="tableData" :columns="columns" @on-sort-change="changeSort"/>
      <Row style="margin: 10px;">
        <div style="float: right;">
          <page :total="count" :current="page" :page-size="size" @on-change="getGitFlowsList"></page>
        </div>
     </Row>
      <Drawer
        title="添加Git流水线"
        v-model="change"
        width="550"
        :mask-closable="true"
        @on-close="drawerClose"
      >
        <i-form ref="formItem" :model="formItem" :label-width="100" :rules="ruleValidate">
          <form-item label="项目" prop="project">
             <i-select v-model="formItem.project" @on-change="handleProjectOnChange">
              <i-option v-for="item in projectOptions" :value="item" :key="item" :label="item"></i-option>
             </i-select>
          </form-item>
          <form-item label="项目经理" prop="step_0">
             <i-select v-model="formItem.step_0" filterable  multiple disabled>
               <i-option v-for="item in formItem.step_0" :value="item" :key="item" :label="item"></i-option>
             </i-select>
          </form-item>
          <form-item label="测试环境(构建)" prop="need_test">
            <RadioGroup v-model="formItem.need_test" type="button">
                <Radio label="true">是</Radio>
                <Radio label="false">否</Radio>
            </RadioGroup>
          </form-item>
          <FormItem
                v-for="(item, index) in formItem.steps"
                :key="index"
                :label="item.name"
                :prop="'steps.' + index + '.users_sel'"
                :rules="{required: true, message: '步骤-' + item.id +'不能为空', trigger: 'change', type: 'array'}">
             <i-select v-model="item.users_sel" filterable  multiple>
               <i-option v-for="user in item.users_all" :value="user" :key="user" :label="user"></i-option>
             </i-select>
          </FormItem>
          <form-item label="提交记录" prop="commit">
             <i-select v-model="formItem.commit" filterable @on-change="handleCommitOnChange">
              <i-option v-for="item in commitOptions" :value="item.id" :key="item.id" :disabled="item.disabled" :label="item.title">
                <div className="commit" :key="1">
                  <div className="title">{{ item.title }}【{{ item.short_id }}】</div>
                  <div className="info" :key="2">
                    <span className="user">{{ item.committer_name }}</span>
                    <span className="time" style="display: 'inline-block'; paddingLeft: 5; color: '#999' ">{{ item.created_at }}</span>
                  </div>
                </div>
              </i-option>
             </i-select>
          </form-item>
          <form-item label="查看详情" prop="diff" v-show="diffUrl_show">
            <a :href="diffUrl" target='_blank'>点击查看提交详情</a>
          </form-item>
          <form-item label="优先级" prop="level">
            <RadioGroup v-model="formItem.level" type="button">
                <Radio label="normal">普通</Radio>
                <Radio label="urgent">紧急</Radio>
            </RadioGroup>
          </form-item>
           <form-item label="提交描述" prop="description" >
            <i-input  v-model="formItem.description" placeholder="请输入项目描述信息" type="textarea"></i-input>
          </form-item>
          <form-item>
           <i-button type="primary" @click="handleSubmit('formItem')">提交</i-button>
           <i-button style="margin-left: 8px" @click="change=false">取消</i-button>
          </form-item>
        </i-form>
        <spin fix v-if="changeLoadingShow">
          <Icon type="load-c" size=18 class="demo-spin-icon-load"></Icon>
          <div>请求中</div>
        </spin>
      </Drawer>
    </Card>
  </div>
</template>
<script>
import Tables from '_c/tables'
import { getList, saveGitFlow, cancelGitFlow, rollbackGitFlow, fetchRollbackCommitsList } from '@/api/gitflow'
import { getGitJob } from '@/api/job'
import { getUserProjectsList, fetchProjectCommitsData, fetchMasterCommitsList } from '@/api/project'
import { forEach } from '@/libs/tools'
import config from '@/config'
export default {
  name: 'GitFlowList',
  components: {
    Tables
  },
  data () {
    const jenkinsUrl = config.jenkinsUrl
    var that = this
    return {
      isGitflowAdd: false,
      project_type_show: false,
      change: false,
      count: 1,
      size: 10,
      page: 1,
      ordering: null,
      status: null,
      tableData: [],
      searchForm: {
        name: null
      },
      columns: [
        { title: 'ID', key: 'id', align: 'center', sortable: 'custom', minWidth: 80 },
        { title: '申请者', key: 'user', align: 'center', minWidth: 100 },
        { title: '项目', key: 'project', align: 'center', minWidth: 110 },
        { title: '描述', key: 'description', align: 'center', minWidth: 220 },
        { title: '申请时间', key: 'time_start', align: 'center', minWidth: 160, sortable: 'custom' },
        { title: '完成时间', key: 'time_end', align: 'center', minWidth: 160, sortable: 'custom' },
        {
          title: '状态',
          key: 'status_verbose',
          align: 'center',
          minWidth: 100,
          sortable: 'custom',
          filters: [
            {
              label: '开始',
              value: 'start'
            },
            {
              label: '待审',
              value: 'todo'
            },
            {
              label: '通过',
              value: 'agree'
            },
            {
              label: '完成',
              value: 'done'
            },
            {
              label: '出错',
              value: 'error'
            },
            {
              label: '拒绝',
              value: 'refuse'
            },
            {
              label: '取消',
              value: 'cancel'
            },
            {
              label: '构建失败',
              value: 'fail'
            },
            {
              label: '已回滚',
              value: 'back'
            }
          ],
          filterMultiple: false,
          filterRemote (value, row) {
            if (value.length > 0) {
              that.status = value[0]
            } else {
              that.status = null
            }
            that.getGitFlowsList()
          }
        },
        {
          title: '最后构建号',
          key: 'num',
          align: 'center',
          minWidth: 100,
          render: (h, params) => {
            let url = jenkinsUrl + '/job/' + params.row.project + 'prod/' + params.row.build_id + '/console'
            return h('a', {
              attrs: {
                href: url,
                target: '_black'
              }
            }, params.row.num)
          }
        },
        {
          title: '操作',
          align: 'center',
          minWidth: 180,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'success',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.$router.push({name: 'GitFlowDetail', query: {id: params.row.id}})
                    // this.$router.push({path: '/GitFlow/GitFlowDetail', query: {id: params.row.id}})
                  }
                }
              }, '详情'),
              h('Poptip', {
                props: {
                  confirm: true,
                  placement: 'bottom',
                  title: '你确定要取消吗?',
                  transfer: true
                },
                on: {
                  'on-ok': () => {
                    this.handleCancel(params)
                  }
                }
              }, [
                h('Button', {
                  props: {
                    type: 'warning',
                    size: 'small',
                    disabled: !(this.$store.state.user.superuser && ['start', 'todo', 'doing'].indexOf(params.row.status) >= 0)
                  },
                  style: {
                    marginRight: '5px'
                  }
                }, '取消')
              ]),
              h('Poptip', {
                props: {
                  confirm: true,
                  placement: 'bottom',
                  title: '你确定要回滚吗?',
                  transfer: true
                },
                on: {
                  'on-ok': () => {
                    this.handleRollback(params)
                  }
                }
              }, [
                h('Button', {
                  props: {
                    type: 'error',
                    size: 'small',
                    disabled: !(this.$store.state.user.superuser && ['done'].indexOf(params.row.status) >= 0)
                  },
                  style: {
                    marginRight: '5px'
                  }
                }, '回滚')
              ])
            ])
          }
        }
      ],
      projectOptions: [],
      commitOptions: [],
      commitOptionsRollbackTmp: [],
      commitOptionsRollback: [],
      rollbackCommit: null,
      diffUrl: null,
      diffUrl_show: false,
      gitLabUrl: null,
      mastersCommits: [],
      changeLoadingShow: false,
      formItem: {
        project: '',
        step_0: [],
        need_test: 'true',
        commit: '',
        level: 'normal',
        description: '',
        steps: [
          {
            id: null,
            name: '',
            group: null,
            users: [],
            users_all: [],
            users_sel: [],
            order: null,
            type: ''
          }
        ]
      },
      listStyle: {
        width: '250px',
        height: '300px'
      },
      ruleValidate: {
        project: [
          { required: true, message: '项目不能为空 !', trigger: 'change' }
        ],
        step_0: [
          { required: true, message: '步骤审批人不能为空', trigger: 'change', type: 'array' }
        ],
        commit: [
          { required: true, message: '提交记录不能为空 !', trigger: 'change' }
        ],
        description: [
          { required: true, message: '描述信息不能为空 !', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    // 初始化页面按钮权限（增删改查操作权限）
    initOperatePerm () {
      let permissions = this.$store.state.user.permissions
      if (permissions.indexOf('add_gitflow') > -1) {
        this.isGitflowAdd = true
      } else {
        this.isGitflowAdd = false
      }
    },
    // 添加gitflow ，打开抽屉，并且加载Form初始化数据
    AddGitflow () {
      this.change = true
      this.InitFormData()
    },
    InitFormData () {
      this.getProjectOptions()
      // 初始化审批步骤Form-Item
      // this.handleAddFormItem()
      this.fetchGitJobData()
    },
    // handleAddFormItem () {

    // },
    fetchGitJobData () {
      getGitJob().then(res => {
        if (res.data.steps instanceof Array) {
          let steps = res.data.steps
          if (res.data.ordered) {
            steps.sort(function (a, b) {
              return a.order - b.order
            })
          }
          this.formItem.steps = steps
        }
      })
    },
    handleProjectOnChange (value) {
      if (value) {
        this.fetchProjectCommitsData(value)
      }
      this.formItem.commit = null
      this.diffUrl = null
    },
    handleCommitOnChange (value) {
      if (value) {
        this.diffUrl = this.gitLabUrl + '/commit/' + value
        this.diffUrl_show = true
      } else {
        this.diffUrl = null
        this.diffUrl_show = false
      }
    },
    fetchProjectCommitsData (value) {
      fetchProjectCommitsData(value).then(res => {
        let commits = res.data.data
        if (commits instanceof Array) {
          // 获取的数据是数组才ok
          // 获取master的提交列表，然后渲染options
          // this.renderCommitOption(commits);
          this.fetchMasterCommitsList(value, commits)
        }
        if (res.data.url) {
          // 设置下gitlab的url
          this.gitLabUrl = res.data.url
        }
        this.formItem.step_0 = res.data.masters
      })
    },
    fetchMasterCommitsList (value, commits) {
      fetchMasterCommitsList(value, commits).then(res => {
        if (res.data instanceof Array) {
          this.mastersCommits = res.data
        }
        this.renderCommitOption(commits)
      })
    },
    // 取可供回滚的commit id 列表
    fetchRollbackCommitsList (id, project) {
      fetchRollbackCommitsList(id).then(res => {
        if (res.data instanceof Array) {
          this.commitOptionsRollbackTmp = res.data
        }
        fetchProjectCommitsData(project).then(res => {
          let commits = res.data.data
          if (commits instanceof Array) {
            this.renderCommitOptionRollback(commits)
          }
        })
      })
    },
    // 回滚构造commit列表用
    renderCommitOptionRollback (commits) {
      if (!(commits instanceof Array)) {
        // 如果commits不是列表，那就返回吧
        return
      }
      commits.map((item, index) => {
        if (this.commitOptionsRollbackTmp.indexOf(item.id) >= 0) {
          this.commitOptionsRollback.push(item)
        }
      })
    },
    renderCommitOption (commits) {
      if (!(commits instanceof Array)) {
        // 如果commits不是列表，那就返回吧
        return
      }
      const mastersCommits = this.mastersCommits
      this.commitOptions = []
      let disabled = false
      commits.map((item, index) => {
        // 只要出现了在主分支的提交id
        // 那么后面的commitid都是已经在master中的了，不用再判断了
        if (!disabled) {
          disabled = mastersCommits.indexOf(item.id) >= 0
        }
        item['disabled'] = disabled
        this.commitOptions.push(item)
      })
    },
    getGitFlowsList (value = 1) {
      this.page = value

      let params = {
        page: this.page,
        ordering: this.ordering,
        status: this.status,
        search: this.searchForm.name
      }
      getList(params).then(res => {
        this.tableData = res.data.results
        this.tableData.map((item, index) => {
          item['num'] = item.build_id ? '#' + item.build_id : ''
        })
        this.count = res.data.count
      })
    },
    drawerClose () {
      let that = this.formItem
      that.project = ''
      that.step_0 = []
      that.need_test = 'true'
      that.commit = ''
      that.description = ''
      that.level = 'normal'
    },
    searchReset () {
      this.searchForm.name = null
    },
    getProjectOptions () {
      let params = {
        code: 'git'
      }
      getUserProjectsList(params).then(res => {
        this.projectOptions = res.data
      })
    },
    changeSort (column) {
      if (column.key === 'id') {
        if (column.order === 'asc') {
          this.ordering = 'id'
        } else {
          this.ordering = '-id'
        }
      } else if (column.key === 'time_start') {
        if (column.order === 'asc') {
          this.ordering = 'time_start'
        } else {
          this.ordering = '-time_start'
        }
      } else if (column.key === 'time_end') {
        if (column.order === 'asc') {
          this.ordering = 'time_end'
        } else {
          this.ordering = '-time_end'
        }
      } else if (column.key === 'status_verbose') {
        if (column.order === 'asc') {
          this.ordering = 'status_code'
        } else {
          this.ordering = '-status_code'
        }
      }
      this.getGitFlowsList()
    },
    handleCancel (params) {
      cancelGitFlow(params.row.id).then(res => {
        if (res.status === 204) {
          this.$Message.success('取消Git工作流成功')
          this.getGitFlowsList()
        }
      })
    },
    // 发起回滚请求
    do_rollback_request (id, scene, commit) {
      rollbackGitFlow(id, scene, commit).then(res => {
        if (res.status === 200) {
          this.$Message.success(res.data.message)
        } else if (res.data.status === 502) {
          this.$Message.error('构建超时,请重新构建')
        } else {
          this.$Message.error(res.data.message)
        }
        // 刷新页面
        this.getGitFlowsList()
      })
    },
    handleRollback (params) {
      // 取所有版本供回滚 选择
      this.fetchRollbackCommitsList(params.row.id, params.row.project)
      // 弹出回滚版本选择框
      this.$Modal.confirm({
        width: '500px',
        title: '回滚版本',
        onOk: () => {
          if (this.rollbackCommit) {
            this.do_rollback_request(params.row.id, 'product', this.rollbackCommit)
          } else {
            this.$Message.error('请选择回滚版本')
          }
        },
        render: (h) => {
          return h('div', [
            h('span', {style: {color: '#515a6e'}}, '请选择回滚版本：'),
            h('Select', {
              props: {
                value: this.rollbackCommit
              },
              on: {
                'on-change': (value) => {
                  this.rollbackCommit = value
                }
              },
              style: {
                width: '200px'
              }
            },
            this.commitOptionsRollback.map(function (item) {
              return h('Option', {
                props: {value: item.id}
              }, item.title)
            })
            )
          ])
        }
      })
    },
    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          forEach(this.formItem.steps, (item, index) => {
            let stepName = 'step_' + (index + 1)
            if (item.users_sel instanceof Array) {
              this.formItem[stepName] = item.users_sel
            }
          })
          // 消息暂时写死只传站内信
          this.formItem['messageKey'] = {sms: '0', dingding: '0', wechat: '0', email: '0', message: '1'}
          this.changeLoadingShow = true
          saveGitFlow(this.formItem).then(res => {
            if (res.data.id > 0) {
              // this.$Notice.success({title: '添加成功！'})
              // that.project = ''
              // that.step_0 = []
              // that.need_test = 'true'
              // // that.commit = ''
              // that.description = ''
              // that.level = 'normal'
              // this.change = false
              // this.getGitFlowsList()
              // 跳转到详情页面
              this.change = false
              this.$router.push({name: 'GitFlowDetail', query: {id: res.data.id}})
            } else {
              // this.$Notice.error({title: res.data})
              this.$Message.error(res.data)
            }
          }).catch(res => {
            console.log(res.response)
            this.$Notice.error({
              title: '操作失败！ 错误状态码:' + res.request.status,
              desc: res.request.responseText
            })
          })
        } else {
          this.$Notice.error({title: '请检查输入框！'})
        }
        this.changeLoadingShow = false
      })
    }
  },
  mounted: function () {
    this.initOperatePerm()
    this.getGitFlowsList()
  }
}
</script>

<style>
.ivu-poptip-body {
  text-align: left !important;
}
</style>
